import styled from 'styled-components';

export const PaymentSafenessStyles = styled.div`
  display: flex;
  margin: 20px auto;
  justify-content: space-between;

  .icon-label {
    display: flex;
    align-items: center;
    gap: 8px;

    ion-icon {
      font-size: 20px;
    }
  }

  .stripe-image {
    width: 117px;
    height: 33px;
  }
`;
